import {INVALID_MOVE, Stage, TurnOrder} from 'boardgame.io/core';

const memberTemplate = {
  species: {
    id: 'monkey',
    emoji: '🐵',
  },
  status: {
    hp: 40,
    atk: 5,
    def: 1,
    walk: 5,
  },
  advanced: {
    prepare: []
  }
};

const memberTempletes = [
  memberTemplate,
  {
    ...memberTemplate,
    species: {
      id: 'sheep',
      emoji: '🐏',
    },
    status: {
      ...memberTemplate.status,
      hp: 52,
      atk: 4,
      def: 0,
      walk: 6,
    },
  },
  {
    ...memberTemplate,
    species: {
      id: 'cat',
      emoji: '🐱',
    },
    status: {
      ...memberTemplate.status,
      hp: 37,
      atk: 4,
      def: 2,
    },
  },
  // {
  //   ...memberTemplate,
  //   species: {
  //     id: 'panda',
  //     emoji: '🐼',
  //   },
  //   status: {
  //     ...memberTemplate.status,
  //     atk: 100,
  //     def: -100,
  //   },
  // },
];

export const CARD_NAME = {
  THINKING: 'THINKING',
  ATK: 'ATK',
  MEMBER: 'MEMBER',
  TRANNING: 'TRANNING',
  DIG: 'DIG',
  REST: 'REST',
  NONE: 'NONE',
  BOMB: 'BOMB',
  ATK_BACK: 'ATK_BACK',
  LONG_THINKING: 'LONG_THINKING',
  LONG_TRANNING: 'LONG_TRANNING',

  // 实际上不存在的卡，只用来名称展示
  COMMON_PREPARE: 'COMMON_PREPARE',
};

export const CARD_TYPE = {
  SHOP_SELECT: 'SHOP_SELECT', // 发现
  INSTANT: 'INSTANT', // 立即生效
  PREPARE: 'PREPARE', // 备战牌
};

export const CARD_TARGET = {
  SELF: 'SELF',
  ALL_ENEMY: 'ALL_ENEMY',
  ONE_ENEMY: 'ONE_ENEMY',
  // 以后加目标选择
};

export const ACTION_TYPE = {
  USE: 'USE', //使用牌
  USE_PREPARE: 'USE_PREPARE', // 放置牌
  PREPARE_BE_ATK: 'PREPARE_BE_ATK', // 备战牌被攻击
  PREPARE_TURN_STEP: 'PREPARE_TURN_STEP', // 备战牌自然丢弃

  TURN_OVER: 'TURN_OVER', // 结束回合

  NONE: 'NONE', // 其实不是真的action
};

export const TAGS = [];

export const cardSetting = {
  [CARD_NAME.THINKING]: {
    type: CARD_TYPE.SHOP_SELECT,
    shop: {
      number: 3,
      pool: [
        { name: CARD_NAME.ATK, weight: 8 },
        { name: CARD_NAME.TRANNING, weight: 2 },
        { name: CARD_NAME.DIG, weight: 2 },
        { name: CARD_NAME.REST, weight: 1 },
        // 备战牌
        { name: CARD_NAME.ATK_BACK, weight: 2 },
        { name: CARD_NAME.LONG_THINKING, weight: 1 },
        { name: CARD_NAME.LONG_TRANNING, weight: 1 },
      ],
    },
  },
  [CARD_NAME.TRANNING]: {
    type: CARD_TYPE.INSTANT,
    target: CARD_TARGET.SELF,
    // 待完善。现在搞这么多可配置，其实以后还要改，看情况，不要直接搞太复杂
  },
  [CARD_NAME.BOMB]: {
    type: CARD_TYPE.INSTANT,
    target: CARD_TARGET.ALL_ENEMY,
  },
  [CARD_NAME.REST]: {
    type: CARD_TYPE.INSTANT,
    target: CARD_TARGET.SELF,
  },
  [CARD_NAME.DIG]: {
    type: CARD_TYPE.SHOP_SELECT,
    shop: {
      number: 2,
      pool: [
        { name: CARD_NAME.ATK, weight: 1 },
        { name: CARD_NAME.NONE, weight: 5 },
        { name: CARD_NAME.BOMB, weight: 1 },

        { name: CARD_NAME.ATK_BACK, weight: 1 },
        { name: CARD_NAME.LONG_THINKING, weight: 1 },
        { name: CARD_NAME.LONG_TRANNING, weight: 1 },
      ],
    },
  },
  [CARD_NAME.NONE]: {
    type: CARD_TYPE.PREPARE,
  },
  [CARD_NAME.ATK_BACK]: {
    type: CARD_TYPE.PREPARE,
  },
  [CARD_NAME.LONG_THINKING]: {
    type: CARD_TYPE.PREPARE,
  },
  [CARD_NAME.LONG_TRANNING]: {
    type: CARD_TYPE.PREPARE,
  },
  [CARD_NAME.COMMON_PREPARE]: {
    type: CARD_TYPE.PREPARE,
  },
};

// Return true if `cells` is in a winning configuration.
function IsVictory(cells, currentPlayer) {
  for (let i = 0; i < cells.length - 2; i++) {
    let equal3 = true;
    const me = currentPlayer;
    for (let j = 0; j < 3; j++) {
      if (cells[i + j] !== me) equal3 = false;
      // console.log('not same', i, j, typeof cells[j], cells[j], typeof me, me, cells);
    }
    if (equal3) return true;
  }
  return false;
}

// Return true if all `cells` are occupied.
function IsDraw(cells) {
  return cells.filter((c) => c === null).length === 0;
}

const SelectMember = (G, ctx, idx = 0, ...otherArgs) => {
  // console.log("SelectMember", {G, ctx, idx, otherArgs});
  const playerData = G.players[ctx.playerID];
  const memberData = playerData?.shop[idx];
  if (!memberData) return INVALID_MOVE;
  const { name, ...others } = memberData;
  const member = others;
  if (!member) return INVALID_MOVE;
  playerData.members.push({ ...member, id: Math.random() });
  playerData.shop = [];
};

const DrawCard = (name, number, options = {}) => {
  const newCards = Array(number)
    .fill({ name })
    .map((one) => ({ ...one, id: Math.random() })); // 以后加随机性用
  return newCards;
};

// 如果有人获胜则返回index，没完返回-1，全死了返回-2
function GetFinalWinner(players) {
  const alivePlayers = players
    .map((player, idx) => ({ ...player, idx }))
    .filter(
      (player) => player.members.filter((one) => one.status.hp > 0).length > 0,
    );
  if (alivePlayers.length > 1) return -1;
  if (alivePlayers.length === 1) return alivePlayers[0].idx;
  return -2;
}

// 暂时没用上
function poolRandomOne(pool, ctx) {
  let weightSum = 0;
  pool.forEach(({ weight }) => {
    weightSum += weight;
  });
  const rand = ctx.random.Die(weightSum);
  let i = 1;
  let theOne = pool[0];
  let
    now = pool[0].weight;
  while (now < rand && i < pool.length) {
    theOne = pool[i];
    now += pool[i].weight;
    i++;
  }
  return theOne;
}

// 选择触发方和目标
function getSimpleSourceAndTarget(G, ctx) {
  const sourcePlayer = G.players[ctx.playerID];
  const targetPlayers = G.players.filter(
    (one, i) => `${i}` !== ctx.playerID,
  );
  // console.log("getSimpleSourceAndTarget", {G, ctx, sourcePlayer, targetPlayers});
  // 先暂定随机选择目标，TODO: 目标选择
  const targetPlayerIndex = Math.max(0, ctx.random.Die(targetPlayers.length) - 1);
  const targetPlayer = targetPlayers[targetPlayerIndex];
  return {
    sourcePlayer,
    targetPlayer,
  };
}

// 选择自己的一个member
function getSelfMember(G, ctx) {
  const sourcePlayer = G.players[ctx.playerID];
  // 先暂定随机选择目标，TODO: 目标选择
  const targetMemberIndex = Math.max(0, ctx.random.Die(sourcePlayer.members.length) - 1);
  const targetMember = sourcePlayer.members[targetMemberIndex];
  return {
    targetMember,
    targetMemberIndex,
  };
}

// 卡片行动
function doCardAction(G, ctx, card) {
  if (cardSetting[card.name]) {
    const setting = cardSetting[card.name];
    switch (setting.type) {
      case CARD_TYPE.SHOP_SELECT: {
        const { shop = {} } = setting;
        const { number = 0, pool = [] } = shop;

        const arr = [];
        pool.forEach(({ name, weight }) => {
          const newCards = Array(weight)
            .fill({ name });
          arr.push(...newCards);
        });
        const newCards = ctx.random.Shuffle(arr).slice(0, number);

        // console.log(theOne);
        const playerData = G.players[ctx.playerID];
        // DrawCard(CARD_NAME.ATK, 3);
        playerData.shop.push(...(newCards));
        break;
      }
      case CARD_TYPE.INSTANT: {
        // 先暂时用卡名来设定，以后改为tag之类的
        switch (card.name) {
          case CARD_NAME.BOMB: {
            const { targetPlayer } = getSimpleSourceAndTarget(G, ctx);
            const atk = 6;

            targetPlayer.members = targetPlayer.members.map((one) => {
              // const newHp = one.status.hp - Math.max(1, atk - one.status.def);
              const newHp = one.status.hp - atk;
              return { ...one, status: { ...one.status, hp: newHp } };
            });
            break;
          }
          case CARD_NAME.REST: {
            const { sourcePlayer } = getSimpleSourceAndTarget(G, ctx);
            sourcePlayer.members[0].status.hp += Math.max(ctx.random.D4(), ctx.random.D4());
            break;
          }
          case CARD_NAME.TRANNING: {
            const { sourcePlayer } = getSimpleSourceAndTarget(G, ctx);
            const addWhat = ctx.random.Die(5) - 1;
            const addList = ['hp', 'hp', 'hp', 'atk', 'def'];
            sourcePlayer.members[0].status[addList[addWhat]]++;
            break;
          }

          default:
            break;
        }
        break;
      }
      case CARD_TYPE.PREPARE: {
        const playerData = G.players[ctx.playerID];
        const {
          targetMember,
          targetMemberIndex,
        } = getSelfMember(G, ctx);
        targetMember.advanced.prepare.push(card);
        break;
      }
      default:
        break;
    }
  }
}

// 抽牌阶段后的备战牌弃牌阶段，最早放的一张备战牌被弃掉
const doPrepareTurn = (G, ctx, prepares) => {
  if (prepares.length === 0) return prepares;
  const card = prepares[0];
  const setting = cardSetting[card.name];
  switch (card.name) {

    // 长考，摸牌
    case CARD_NAME.LONG_THINKING: {
      const playerData = G.players[ctx.currentPlayer];
      const newCards = DrawCard(CARD_NAME.THINKING, 2);
      playerData.hand.push(...newCards);
      break;
    }

    // 锻炼
    case CARD_NAME.LONG_TRANNING: {
      const playerData = G.players[ctx.currentPlayer];
      const addWhat = ctx.random.Die(2) - 1;
      const addList = ['atk', 'def'];
      playerData.members[0].status[addList[addWhat]]++;
      break;
    }
    default:
      break;
  }
  addToLog({ card: card, actionType: ACTION_TYPE.PREPARE_TURN_STEP }, G, ctx);
  return prepares.slice(1);
}

// 攻击结算
function doAtkStep(sourceMember, targetMembers, G, ctx) {
  function normalAttack(targetMember, atk) {
    const newHp = targetMember.status.hp - Math.max(1, atk - targetMember.status.def);
    const newStatus = { ...targetMember.status, hp: newHp };
    targetMember.status = newStatus;
  }

  targetMembers.forEach((one) => {
    // 备战卡结算
    if (one?.advanced?.prepare?.length > 0) {
      const card = one.advanced.prepare[0];
      switch (card.name) {

        // 反击
        case CARD_NAME.ATK_BACK: {
          const { atk: myAtk } = one.status;
          const { atk: sourceAtk } = sourceMember.status;
          normalAttack(sourceMember, myAtk + sourceAtk);
          break;
        }
        default:
          break;
      }
      addToLog({ card: card, actionType: ACTION_TYPE.PREPARE_BE_ATK }, G, ctx);
      one.advanced.prepare = one?.advanced?.prepare?.slice(1);
    }


    // 一般攻击结算
    const { atk } = sourceMember.status;
    normalAttack(one, atk);
    // return { ...one, status: newStatus };
  });
}

// 筛选出非秘密信息返回
function StripSecrets(G, playerID) {
  // console.log("StripSecrets", G, playerID);
  const playerData = G.players[playerID];
  const newG = { ...G };
  newG.players = newG.players.map((player, idx) => {
    const newPlayer = { ...player };
    // 只有自己的信息能完整返回
    if (`${idx}` === playerID || playerID === null) return newPlayer; // 让没有playerID也能运行。否则本地双人对战会出问题，怪

    // 敌人的手牌不显示
    newPlayer.hand = newPlayer.hand.map(one => {
    });
    newPlayer.shop = newPlayer.shop.map(one => {
    });

    // 敌人的备战卡不显示
    newPlayer.members = newPlayer.members.map(member => {
      let newMember = { ...member };
      const newPrepare = newMember.advanced.prepare.map(one => {
      });
      newMember = {
        ...newMember,
        advanced: {
          ...newMember.advanced,
          prepare: newPrepare,
        }
      };
      return newMember;
    })
    return newPlayer;
  });
  return newG;
}

// 添加到log
function addToLog(action, G, ctx) {
  let { card = {}, actionType = ACTION_TYPE.USE } = action || {};
  const logCard = { ...card };
  const logCardSetting = cardSetting[logCard?.name];
  // 不能暴露盖卡的卡名
  if (actionType === ACTION_TYPE.USE && logCardSetting?.type === CARD_TYPE.PREPARE) {
    logCard.name = CARD_NAME.COMMON_PREPARE;
    logCard.type = logCardSetting.type;
    actionType = ACTION_TYPE.USE_PREPARE;
  }

  // status变化
  const playersStatus = G.players.map(player => {
    const { members, info } = player;
    return {
      info, members: members.map(member => {
        const { status } = member;
        return { status };
      })
    };
  });
  if (G.log) {
    let newCount = (G?.log?.lastActionCount || 0) + 1;
    G.log.lastActions.push({
      playerID: ctx.playerID || ctx.currentPlayer,
      actionType: actionType,
      card: logCard,
      playersStatus,
      actionCount: newCount,
    });
    G.log.lastActionCount = newCount;
  } else {
    // console.log("lastAction not found?");
  }
}

// 初始数据设置
export const setupMethod = (ctx, setupData) => {
  console.log("ctx, setupData=", ctx, setupData);
  //ctx.matchData: Array(3)
  // 0: {id: 0, name: "WSC500", isConnected: true}
  // 1: {id: 1, name: "daiFish", isConnected: true}
  // 2: {id: 2, name: "Sea5", isConnected: true}
  return ({
    // hand: Array(ctx.numPlayers).fill(0),
    players: [
      ...Array(ctx.numPlayers)
        .fill({})
        .map(({}, idx) => {
          let name = `玩家${idx + 1}`;
          if (ctx.matchData && ctx.matchData[idx]) {
            name = ctx.matchData[idx].name;
          }
          return ({
            info: {
              name,
            },
            hand: DrawCard(CARD_NAME.THINKING, idx), // 后手补偿
            members: [],
            shop: [],
          })
        }),
    ],
    log: {
      lastActionCount: 0,
      lastActions: [{ playerID: null, card: null, playersStatus: null, actionCount: 0 }]
    }, //{ playerID: null, card: null, playersStatus: null, actionCount: 0 }
  })
};

export const BattleCardGameRule = {
  name: 'cat-sheep-card-game',
  setup: setupMethod,
  minPlayers: 1,
  maxPlayers: 8,
  // 筛选出哪些是本玩家能看见的，哪些不能看见。返回new G
  playerView: (G, ctx, playerID) => {
    return StripSecrets(G, playerID);
  },
  phases: {
    selectFirstMember: {
      onBegin: (G, ctx) => {
        G.players = G.players.map((player) => {
          const { shop, ...others } = player;
          const deck = ctx.random.Shuffle(memberTempletes);
          const newShop = deck
            .slice(0, 3)
            .map((one) => ({ ...one, name: CARD_NAME.MEMBER })); // 抽出3个角色放入选项中
          return { ...others, shop: newShop };
        });
      },
      moves: { SelectMember },
      turn: {
        moveLimit: 1,
        activePlayers: { all: Stage.NULL },
      },
      endIf: (G, ctx) => {
        const haveNotMember = G.players.filter(
          (player) => player.members.length === 0,
        ).length;
        return haveNotMember === 0; // 所有人都选了英雄就结束这个phase
      },
      onEnd: (G, ctx) => {
      },
      next: 'battle',
      start: true,
    },
    battle: {
      moves: {
        UseCard: {
          client: false, // 非客户端结算。因为客户端没有必要信息。
          move: (G, ctx, idx = 0) => {
            const playerData = G.players[ctx.playerID];
            const card = playerData.hand[idx];
            if (!card || playerData.shop.length > 0) return INVALID_MOVE; // 商店能买的时候不能用卡。这个看看以后要不要用stage来做限制
            playerData.hand = playerData.hand.filter((one, i) => i !== idx);

            // 生成log
            addToLog({ card, actionType: ACTION_TYPE.USE }, G, ctx); // 先出攻击log，再出反击log，所以要在这里add，防止顺序反
            switch (card.name) {
              case CARD_NAME.THINKING: {
                doCardAction(G, ctx, card);
                break;
              }
              case CARD_NAME.ATK: {
                const { targetPlayer, sourcePlayer } = getSimpleSourceAndTarget(G, ctx);
                const sourceMember = sourcePlayer.members[0];
                const targetMembers = [targetPlayer.members[0]];
                doAtkStep(sourceMember, targetMembers, G, ctx);
                break;
              }
              default:
                doCardAction(G, ctx, card);
                break;
            }
            addToLog({ actionType: ACTION_TYPE.NONE }, G, ctx); // 同步status变化
          }
        },
        BuyFromShop: (G, ctx, idx = 0) => {
          const playerData = G.players[ctx.currentPlayer];
          const card = playerData.shop[idx];
          if (!card) return INVALID_MOVE;
          playerData.hand.push(card);
          playerData.shop = [];
        },
      },
      turn: {
        order: {
          // Get the initial value of playOrderPos.
          // This is called at the beginning of the phase.
          first: (G, ctx) => 0,

          // Get the next value of playOrderPos.
          // This is called at the end of each turn.
          // The phase ends if this returns undefined.
          next: (G, ctx) => (ctx.playOrderPos + 1) % ctx.numPlayers,

          // OPTIONAL:
          // Override the initial value of playOrder.
          // This is called at the beginning of the game / phase.
          // playOrder: (G, ctx) => [...],
        },
        onBegin: (G, ctx) => {
          const playerData = G.players[ctx.currentPlayer]; // 这里不能用ctx.playerID，怪
          // console.log("ctx=", ctx, playerData);

          // 清空lastActions
          // if (G.log) G.log.lastActions = [];

          // 抽卡
          const newCards = DrawCard(CARD_NAME.THINKING, 2);
          playerData.hand.push(...newCards);

          // 备战卡弃置
          playerData.members.forEach(member => {
            const prepares = member?.advanced?.prepare;

            const newPrepare = doPrepareTurn(G, ctx, prepares);
            member.advanced.prepare = newPrepare;
          });
        },
        onEnd: (G, ctx) => {
          const playerData = G.players[ctx.currentPlayer];
          addToLog({ actionType: ACTION_TYPE.TURN_OVER }, G, ctx);
        },
      },
    },
  },

  moves: {
    clickCell: (G, ctx, id) => {
      if (G.cells[id] === null) {
        // console.log("clickCell start", ctx.currentPlayer);
        G.cells[id] = ctx.currentPlayer;
        ctx.events.endTurn();
        // console.log("clickCell over", ctx.currentPlayer);
      }
    },
  },
  turn: {
    // first: 0,
    // moveLimit: 1,
    // order: TurnOrder.ONCE,
    // next: (G, ctx) => (ctx.playOrderPos + 1) % ctx.numPlayers,
  },

  endIf: (G, ctx) => {
    if (ctx.phase === 'battle') {
      const finalWinner = GetFinalWinner(G.players);
      if (finalWinner >= 0) {
        return { winner: `${finalWinner}` };
      }
      if (finalWinner === -2) {
        return { draw: true };
      }
    }
  },
  events: {
    endPhase: false,
    setPhase: false,
    endGame: false,
  },
  ai: {
    enumerate: (G, ctx, aiPlayerID) => {
      const moves = [];
      const playerData = G.players[aiPlayerID];
      // console.log("ai enumerate", {G, ctx, aiPlayerID, playerData});
      if (ctx.phase === 'battle') {
        const handLen = playerData.hand.length;
        const shopLen = playerData.shop.length;
        if (shopLen > 0) {
          moves.push(...playerData.shop.map(
            (one, idx) => ({ move: 'BuyFromShop', args: [idx] }),
          ));
        } else {
          if (handLen > 0) {
            moves.push(...playerData.hand.map(
              (one, idx) => ({ move: 'UseCard', args: [idx] }),
            ));
          }
          moves.push({ event: 'endTurn' });
        }
      } else if (ctx.phase === 'selectFirstMember') {
        moves.push(...playerData.shop.map(
          (one, idx) => ({ move: 'SelectMember', args: [idx] }),
        ));
      }

      // for (let i = 0; i < 9; i++) {
      //   if (G.cells[i] === null) {
      //     moves.push({ move: 'clickCell', args: [i] });
      //   }
      // }
      // console.log("ai enumerate moves=", ctx.phase, playerData, moves);
      return moves;
    },
  },
};
